export enum Steps {
  User = '0',
  Company = '1',
}
